module.exports = __webpack_public_path__ + "img/3.fe7d0129.jpg";